// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-width[data-v-7819e849] {\n  width: 150px;\n  margin-right: 16px;\n  margin-bottom: 10px;\n}\n.select-bottom[data-v-7819e849] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
